import React, { useEffect, useRef, useState } from "react";

const Dropdown = ({ options, selected, onSelect, label, mutation = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    onSelect(option);
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className={`${
          mutation
            ? "bg-quinary text-white"
            : "border-2 border-quinary text-secondary"
        } rounded-full px-3 ${
          mutation ? "py-[3px] text-[13.5px]" : "py-[1.3px] text-sm"
        } font-medium tracking-wide flex items-center gap-2`}
      >
        {selected || label}
        <img
          src="/assets/dropdown-arrow.svg"
          alt="Dropdown"
          className={`mt-[2.5px] h-1.5 ${
            mutation && "filter invert brightness-0"
          }`}
        ></img>
      </button>

      {isOpen && (
        <ul className="absolute right-0 mt-2 bg-white border-2 border-quinary rounded-lg shadow-lg z-10 w-40 divide-y-2 divide-[#00000014]">
          {options.map((option, index) => (
            <li
              key={index}
              onClick={() => handleOptionClick(option)}
              className="px-4 py-2 hover:bg-quinary hover:text-white cursor-pointer text-sm font-medium"
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
